<template>
  <div
    class="context-wrap"
    :class="newContext ? 'highlighted' : ''"
  >
    <context-header
      class="context-wrap__header"
      showPairForm
      :context.sync="localContext"
      :context-id="contextId"
      :new-context="newContext"
      :newPair="newPair"
      :has-flow-entity="hasFlowEntity"
      :is-pattern-view="isPatternView"
      :localIntent="localIntent"
      @hide-pair-form="hidePairForm"
      @delete="$emit('delete')"
      @update="(name) => $emit('update', name)"
      @add="showPairForm = true"
    />
    <context-pair-form
      v-if="showPairForm || newContext"
      :is-pattern-view="isPatternView"
      :intentErrors="intentErrors"
      :pattern.sync="newPair.pattern"
      :utterance.sync="newPair.utterance"
      :intent.sync="$v.localIntent.$model"
      @reset-intent-validation="resetIntentValidation()"
    />
  </div>
</template>

<script>
import { intentValidationMixin } from '@/mixins/intent-validation.mixin'
import contextHeader from './context_header'
import contextPairForm from './context_pair_form'

export default {
  components: {
    contextHeader,
    contextPairForm
  },

  mixins: [intentValidationMixin],

  props: {
    context: {
      type: String,
      default: ''
    },
    newContext: {
      type: Boolean,
      default: false
    },
    contextId: String,
    hasFlowEntity: Boolean,
    isPatternView: Boolean
  },

  computed: {
    localContext: {
      get () {
        return this.context
      },
      set (value) {
        this.$emit('update:context', value)
      }
    },

    localIntent: {
      get () {
        return this.newPair.intent
      },
      set (intent) {
        this.newPair.intent = intent
      }
    }
  },

  data () {
    const defaultIntent = {
      type: 'TEXT',
      name: '',
      customData: {
        confirmationPhrase: null
      }
    }

    return {
      showPairForm: false,
      newPair: {
        pattern: {
          pattern: '',
          entities: []
        },
        utterance: '',
        intent: { ...defaultIntent }
      },
      defaultIntent
    }
  },

  methods: {
    hidePairForm () {
      this.showPairForm = false
    },

    resetIntentValidation () {
      this.$nextTick(() => { this.$v.localIntent.name.$reset() })
    }
  }
}
</script>

<style lang="scss" scoped>
    .context-wrap {
        display: flex;
        flex-direction: column;
        flex-grow: 1;

        &.highlighted {
            border: solid 1px $or-blue;
        }
    }
</style>
